import axios from 'axios';
import { filePondDeleteMethod } from './filepond-delete-method';
import { chunkedUpload } from './chunked-upload.js';
import { fileTypes } from './file-types.js';

//const UPLOAD_PATH = '/orders/upload';

const UPLOAD_PATH = '/files/upload';

export function fpServer()
{

    return {
        //url: '/'
        // url: '/orders/upload',
        // method: 'POST',
        // withCredentials: true,
        // timeout: 7000,
        // onload: null,
        // onerror: (e) => console.log(e),
        // //ondata: (formData) => this.onFileUploadData(formData),
        // headers: {
        //   "X-CSRF-TOKEN": this.csrfToken, //$("#token").attr('content'),
        // }

        revert: filePondDeleteMethod,

        remove: filePondDeleteMethod,

        process: (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
            if (file.name.startsWith("client_feedback")) {
                error("File names starting with 'client_feedback' are not allowed.");
                setTimeout(() => {
                    this.$refs.pond.removeFile(file.id);
                }, 0);
                return {
                    abort: () => {
                        abort();
                    }
                };
            }
            var canChunkUpload = options.chunkUploads;
            var shouldChunkUpload = canChunkUpload && file.size > options.chunkSize;
            var willChunkUpload = canChunkUpload && (shouldChunkUpload || options.chunkForce);

            //check if file is chunkable
            if (file instanceof Blob && willChunkUpload) {
                let chunkOptions = Object.assign(
                    {}, options, {
                        orderId: this.orderId,
                        orderFileType: fileTypes[this.uploadFileType]
                    }
                )
                //return chunkedUpload(...arguments);
                return chunkedUpload.apply(this, [fieldName, file, metadata, load, error, progress, abort, transfer, chunkOptions, this.csrfToken]);
            }

            const formData = new FormData();
            const abortController = new AbortController();

            // fieldName is the name of the input field
            // file is the actual file object to send
            formData.append('files[]', file, file.name);
            formData.append('orderfiletype', fileTypes[this.uploadFileType]);
            formData.append('orderid', this.orderId);

            let cancelToken = axios(
                {
                    method: 'POST',
                    url: UPLOAD_PATH,
                    data: formData,
                    signal: abortController.signal,

                    // Should call the progress method to update the progress to 100% before calling load
                    // Setting computable to false switches the loading indicator to infinite mode
                    onUploadProgress: function (e) {
                        let { lengthComputable, loaded, total } = e;

                        // Do whatever you want with the native progress event
                        EventBus.$emit(
                            'filepond-progress', {
                                lengthComputable,
                                loaded,
                                total
                            }
                        )

                        progress(lengthComputable, loaded, total);
                    },
                }
            ).then(
                result => {
                // the load method accepts either a string (id) or an object
                    let {files} = result.data;
                load(files[0].id);
                //if we have renamed the file
                    //add this to the queue for processing later
                    if (files[0].renamedFilename) {
                        this.addToFileRenameQueue(file, { renamedFilename: files[0].renamedFilename });
                    }

                    //@TODO - remove from array if user deletes this file?
                    this.files = this.files.concat(files)
                }
            ).catch(
                (err) => {
                    // Can call the error method if something is wrong, should exit after
                    error(err.message || 'oh no')
                }
            )

        return {

            abort: () => {
                // This function is entered if the user has tapped the cancel button
                abortController.abort();

                // Let FilePond know the request has been cancelled
                abort();
            }
            };
        }
    };
};
